(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("cqXmx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useUrlTransformer", function () { return $90d5f5e5c225a7f6$export$35346fa89da2bdc9; });
$parcel$export(module.exports, "Content", function () { return $90d5f5e5c225a7f6$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "make", function () { return $90d5f5e5c225a7f6$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $90d5f5e5c225a7f6$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $90d5f5e5c225a7f6$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $8u0V4 = parcelRequire("8u0V4");

var $7KlbQ = parcelRequire("7KlbQ");

var $kJhYp = parcelRequire("kJhYp");

var $bygWp = parcelRequire("bygWp");

var $ePRCc = parcelRequire("ePRCc");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $bZsVp = parcelRequire("bZsVp");

var $37BLX = parcelRequire("37BLX");

var $cdK26 = parcelRequire("cdK26");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $Tbt6s = parcelRequire("Tbt6s");

var $dhngN = parcelRequire("dhngN");

var $8adqh = parcelRequire("8adqh");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");
function $90d5f5e5c225a7f6$export$35346fa89da2bdc9(enabledOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    $8E2YL.use(undefined);
    var match = $efwy1.use(undefined);
    var setUrlTransformer = match.setUrlTransformer;
    var namespace = match.namespace;
    var match$1 = $9pMGg.use(undefined);
    var smartnavApiHost = match$1.smartnavApiHost;
    var match$2 = $8u0V4.getValues(match$1.market);
    var country = match$2.country;
    var currency = match$2.currency;
    var urlTransformer = function urlTransformer(loc, baseUrl) {
        var productId = $2whNH.flatMap(loc.quickNav, function(nav) {
            return nav.productId;
        });
        var variantId = $2whNH.flatMap(loc.quickNav, function(nav) {
            return nav.variantId;
        });
        var product = $2whNH.flatMap(productId, function(pi) {
            return $bZsVp.getProductById(smartnavApiHost, currency, country, pi);
        });
        var variant = $2whNH.flatMap(variantId, function(vi) {
            return $2whNH.flatMap(product, function(p) {
                return $i7mYY.getBy($7KlbQ.getAllVariants(p), function(v) {
                    return v.id === vi;
                });
            });
        });
        var newUrl = variant !== undefined ? $2whNH.flatMap(variant.link, $bygWp.maybeMakeUrl) : product !== undefined ? $2whNH.flatMap(product.link, $bygWp.maybeMakeUrl) : undefined;
        return $2whNH.map($2whNH.map($2whNH.keep(newUrl, function(newUrl) {
            return newUrl.hostname === baseUrl.hostname;
        }), function(newUrl) {
            newUrl.protocol = baseUrl.protocol;
            return newUrl;
        }), function(newUrl) {
            return new URL($kJhYp.toBaseUrl(namespace, newUrl.href));
        });
    };
    $g85JO.useEffect(function() {
        if (enabled) $iv6Yc._1(setUrlTransformer, function(param) {
            return urlTransformer;
        });
        return function(param) {
            $iv6Yc._1(setUrlTransformer, function(param) {});
        };
    }, [
        namespace,
        enabled
    ]);
}
function $90d5f5e5c225a7f6$var$PDPApp$Content(Props) {
    var match = $hBcYV.useRouter(undefined);
    var shopifyProductId = $cdK26.getProductPageProductId(undefined);
    var productId = $2whNH.orElse(match.anyProductId, shopifyProductId);
    $90d5f5e5c225a7f6$export$35346fa89da2bdc9($cdK26.isProductPage(undefined), undefined);
    if (productId !== undefined) return /*#__PURE__*/ $g85JO.createElement($Tbt6s.make, {
        productId: productId
    });
    else return null;
}
$90d5f5e5c225a7f6$var$PDPApp$Content.displayName = "PDPApp.Content";
var $90d5f5e5c225a7f6$export$7c6e2c02157bb7d2 = {
    make: $90d5f5e5c225a7f6$var$PDPApp$Content
};
function $90d5f5e5c225a7f6$var$PDPApp(Props) {
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    var match = $hBcYV.useRouter(undefined);
    var match$1 = $8E2YL.use(undefined);
    var config = match$1.config;
    var match$2 = $efwy1.use(undefined);
    var namespace = match$2.namespace;
    var pageOnlyHasPDP = $37BLX.countBottombarElementsByNamespace(namespace) === 0 && $37BLX.countInlineElementsByNamespace(namespace) === 0 && $37BLX.countLauncherElementsByNamespace(namespace) === 0 && $37BLX.countSectionElementsByNamespace(namespace) === 0;
    var tmp = {
        config: config,
        embedType: embedType,
        children: null
    };
    if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
    var tmp$1;
    var tmp$2 = match.route;
    tmp$1 = typeof tmp$2 === "number" || !(tmp$2.TAG === /* QuickView */ 3 && pageOnlyHasPDP) ? null : /*#__PURE__*/ $g85JO.createElement($b8WNX.make, {});
    return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "pdp",
        portal: false,
        children: /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp, tmp$1, /*#__PURE__*/ $g85JO.createElement($90d5f5e5c225a7f6$var$PDPApp$Content, {}), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: config.settings.cart,
            children: /*#__PURE__*/ $g85JO.createElement($8adqh.make, {})
        }))
    });
}
$90d5f5e5c225a7f6$var$PDPApp.displayName = "PDPApp";
var $90d5f5e5c225a7f6$export$dd44f18ab656f3bb = $90d5f5e5c225a7f6$var$PDPApp;
var $90d5f5e5c225a7f6$export$aa541d093b11ace2 = $90d5f5e5c225a7f6$var$PDPApp;
 /* react Not a pure module */ 
});
parcelRegister("37BLX", function(module, exports) {

$parcel$export(module.exports, "countInlineElementsByNamespace", function () { return $245f535c80fa97b7$export$7460c80d7c5cf75c; });
$parcel$export(module.exports, "countBottombarElementsByNamespace", function () { return $245f535c80fa97b7$export$3a44f3abf1840775; });
$parcel$export(module.exports, "countLauncherElementsByNamespace", function () { return $245f535c80fa97b7$export$ac754b9504a93a08; });
$parcel$export(module.exports, "countSectionElementsByNamespace", function () { return $245f535c80fa97b7$export$b75c7a415a35e365; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $h6rW7 = parcelRequire("h6rW7");
function $245f535c80fa97b7$export$36d3479b5d03ac38(el) {
    var namespace = el.getAttribute("data-namespace");
    if (namespace == null) return $h6rW7.empty;
    else return $h6rW7.fromString(namespace);
}
function $245f535c80fa97b7$export$d0ebfc305a7a6844(elements, namespace) {
    var namespace$1 = $2whNH.getWithDefault(namespace, $h6rW7.empty);
    return $i7mYY.keep($2whNH.getWithDefault($2whNH.map(elements, $d3YYW.values), []), function(element) {
        return $7bjme.equal($245f535c80fa97b7$export$36d3479b5d03ac38(element), namespace$1);
    });
}
function $245f535c80fa97b7$export$a82d8d7911f406ff(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace);
}
function $245f535c80fa97b7$export$310f9fbcf0732046(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace);
}
function $245f535c80fa97b7$export$677c1fd84b0cad4f(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace);
}
function $245f535c80fa97b7$export$bbd7846266bc9fe8(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace);
}
function $245f535c80fa97b7$export$58368f7b4fc9b76d(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace);
}
function $245f535c80fa97b7$export$7460c80d7c5cf75c(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace).length;
}
function $245f535c80fa97b7$export$3a44f3abf1840775(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace).length;
}
function $245f535c80fa97b7$export$ac754b9504a93a08(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace).length;
}
function $245f535c80fa97b7$export$b75c7a415a35e365(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace).length;
}
function $245f535c80fa97b7$export$65ea36736e2b48c7(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace).length;
}
 /* No side effect */ 
});

parcelRegister("8adqh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5f19ab6e1e369baa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $5f19ab6e1e369baa$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("7YjQi"));
});
function $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($5f19ab6e1e369baa$var$component, Props);
}
$5f19ab6e1e369baa$var$MiniCartDrawer_Lazy.displayName = "MiniCartDrawer_Lazy";
var $5f19ab6e1e369baa$export$dd44f18ab656f3bb = $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("7YjQi", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1QPUT")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("ebd07"))
]).then(function() {
    return parcelRequire("67Br4");
});

});


parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("k6OMq"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("k6OMq", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("cYw4f")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1QPUT")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});



parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

parcelRegister("2Mb3w", function(module, exports) {

$parcel$export(module.exports, "getBrowser", function () { return $2058a3ec51237c4b$export$89e15fc796a4a429; });
$parcel$export(module.exports, "isSafariVersion__16_3", function () { return $2058a3ec51237c4b$export$91773661b17fb447; });
$parcel$export(module.exports, "getOS", function () { return $2058a3ec51237c4b$export$34ee789f81ad4cb9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");
var $2058a3ec51237c4b$export$60cc2146340a7149 = function getAppVersion() {
    return navigator.appVersion;
};
var $2058a3ec51237c4b$export$7935961ef7719cb0 = function getUserAgent() {
    return navigator.userAgent;
};
function $2058a3ec51237c4b$export$89e15fc796a4a429(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var chromeAgent = userAgentString.indexOf("Chrome") > -1;
    var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
    var safariAgent = userAgentString.indexOf("Safari") > -1;
    if (chromeAgent) return /* Chrome */ 0;
    else if (firefoxAgent) return /* Firefox */ 2;
    else if (safariAgent) return /* Safari */ 1;
    else return /* UnknownBrowser */ 3;
}
function $2058a3ec51237c4b$export$91773661b17fb447(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var match = $2058a3ec51237c4b$export$89e15fc796a4a429(undefined);
    if (match !== 1) return false;
    else return userAgentString.includes("iPhone OS 16_3");
}
function $2058a3ec51237c4b$export$34ee789f81ad4cb9(param) {
    var appVersion = $iv6Yc._1($2058a3ec51237c4b$export$60cc2146340a7149, undefined);
    if (appVersion.includes("Win")) return /* Windows */ 1;
    else if (appVersion.includes("iPhone OS")) return /* IOS */ 3;
    else if (appVersion.includes("Mac")) return /* Mac */ 0;
    else if (appVersion.includes("Linux")) return /* Linux */ 2;
    else return /* UnknownOs */ 4;
}
 /* No side effect */ 
});

parcelRegister("2XXXw", function(module, exports) {

$parcel$export(module.exports, "ScrollRestorationLocalStorage", function () { return $228f9a1798c51d97$export$791f6fca0d60efd9; });
$parcel$export(module.exports, "setBreakingPoint", function () { return $228f9a1798c51d97$export$1dfa5e58b4233c3; });
$parcel$export(module.exports, "removeBreakingPoint", function () { return $228f9a1798c51d97$export$16e7fafba7e176d; });
$parcel$export(module.exports, "setCurrentScroll", function () { return $228f9a1798c51d97$export$6e32c7a2bca8fb40; });
$parcel$export(module.exports, "getClosestBreakingPoint", function () { return $228f9a1798c51d97$export$69a851a551f434f5; });
$parcel$export(module.exports, "setScrollLock", function () { return $228f9a1798c51d97$export$a2324b57a6a5ec84; });
$parcel$export(module.exports, "clearScrollLock", function () { return $228f9a1798c51d97$export$14e0addec6650b88; });
$parcel$export(module.exports, "getScroll", function () { return $228f9a1798c51d97$export$ff41c598de81c14a; });
$parcel$export(module.exports, "isBlockingOnScrollEvent", function () { return $228f9a1798c51d97$export$51e57029e6716073; });
$parcel$export(module.exports, "useScrollRestoration", function () { return $228f9a1798c51d97$export$c4ffdfe23dd48040; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $79vie = parcelRequire("79vie");

var $58Tj9 = parcelRequire("58Tj9");

var $jVmMx = parcelRequire("jVmMx");

var $kJhYp = parcelRequire("kJhYp");

var $gO2mJ = parcelRequire("gO2mJ");

var $8wpG4 = parcelRequire("8wpG4");

var $efwy1 = parcelRequire("efwy1");

var $25dxq = parcelRequire("25dxq");
$gO2mJ.setScrollRestoration("manual");
function $228f9a1798c51d97$export$a91724a679733655(position) {
    if (typeof position === "number") return $iv6Yc._2($jVmMx.Encode.array, [
        "Zero"
    ], $jVmMx.Encode.string);
    else if (position.TAG === /* Pixels */ 0) return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Pixels", $jVmMx.Encode.$$int);
    else return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Index", $jVmMx.Encode.$$int);
}
var $228f9a1798c51d97$var$zero = $79vie.map($79vie.index(0, $jVmMx.Decode.exactString("Zero")), function(param) {
    return /* Zero */ 0;
});
var $228f9a1798c51d97$var$pixels = $jVmMx.Decode.deccoVariantWithPayload("Pixels", $79vie.$$int, function(v) {
    return {
        TAG: /* Pixels */ 0,
        _0: v
    };
});
var $228f9a1798c51d97$var$index = $jVmMx.Decode.deccoVariantWithPayload("Index", $79vie.$$int, function(v) {
    return {
        TAG: /* Index */ 1,
        _0: v
    };
});
var $228f9a1798c51d97$export$932a824d711ed6ad = $79vie.oneOf($228f9a1798c51d97$var$zero, [
    $228f9a1798c51d97$var$pixels,
    $228f9a1798c51d97$var$index
]);
function $228f9a1798c51d97$var$set(key, value) {
    $8wpG4.set(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }, JSON.stringify($228f9a1798c51d97$export$a91724a679733655(value)));
}
function $228f9a1798c51d97$var$$$delete(key) {
    $8wpG4.$$delete(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    });
}
function $228f9a1798c51d97$var$get(key) {
    return $2whNH.mapWithDefault($8wpG4.get(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }), /* Zero */ 0, function(position) {
        var result = $79vie.decodeValue(JSON.parse(position), $228f9a1798c51d97$export$932a824d711ed6ad);
        if (result.TAG === /* Ok */ 0) return result._0;
        else return /* Zero */ 0;
    });
}
var $228f9a1798c51d97$export$791f6fca0d60efd9 = {
    set: $228f9a1798c51d97$var$set,
    $$delete: $228f9a1798c51d97$var$$$delete,
    get: $228f9a1798c51d97$var$get
};
var $228f9a1798c51d97$export$f3a17d4d921911b3 = {};
var $228f9a1798c51d97$export$d4351b0ee1c8c8c6 = {
    contents: undefined
};
var $228f9a1798c51d97$export$1f6d3e4fc8cedc8e = {
    contents: {}
};
function $228f9a1798c51d97$export$6bbf62f168c1dddc($$location, id, position) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($$location));
    var bucket = $d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey);
    $228f9a1798c51d97$var$set(id, position);
    if (bucket !== undefined) $loT9g.valFromOption(bucket)[id] = position;
    else $228f9a1798c51d97$export$f3a17d4d921911b3[bucketKey] = $d3YYW.fromArray([
        [
            id,
            position
        ]
    ]);
}
function $228f9a1798c51d97$export$1dfa5e58b4233c3(paddingOpt, id, center) {
    var padding = paddingOpt !== undefined ? paddingOpt : 0;
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents[id] = {
        center: center,
        padding: padding
    };
}
function $228f9a1798c51d97$export$16e7fafba7e176d(idToDelete) {
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents = $d3YYW.fromArray($i7mYY.keepMap($d3YYW.entries($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(param) {
        var id = param[0];
        if (id !== idToDelete) return [
            id,
            param[1]
        ];
    }));
}
function $228f9a1798c51d97$export$684cfbe7f928b61e(param) {
    return $58Tj9.stableSortBy($d3YYW.values($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(a, b) {
        if (a.center > b.center) return 1;
        else if (a.center < b.center) return -1;
        else return 0;
    });
}
function $228f9a1798c51d97$export$6e32c7a2bca8fb40(namespace, id, target) {
    $228f9a1798c51d97$export$6bbf62f168c1dddc($kJhYp.getStatesByNamespace(namespace).current, id, target);
}
function $228f9a1798c51d97$export$69a851a551f434f5(currentScroll, targetScroll) {
    var allPoints = $228f9a1798c51d97$export$684cfbe7f928b61e(undefined);
    return $i7mYY.reduce(allPoints, targetScroll, function(prev, curr) {
        if ((curr.center - curr.padding | 0) <= currentScroll && (curr.center + curr.padding | 0) >= currentScroll) return currentScroll;
        else if (curr.center <= currentScroll) return curr.center;
        else return prev;
    });
}
function $228f9a1798c51d97$export$a2324b57a6a5ec84(dref) {
    $2whNH.map($loT9g.nullable_to_opt(dref.current), function(el) {
        $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = {
            element: el,
            boundingClientRect: el.getBoundingClientRect()
        };
    });
}
function $228f9a1798c51d97$export$14e0addec6650b88(param) {
    $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = undefined;
}
function $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, id) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    var fromBucket = $2whNH.flatMap($d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey), function(bucket) {
        return $d3YYW.get(bucket, id);
    });
    if (fromBucket !== undefined) return fromBucket;
    if (!localStorage) return /* Zero */ 0;
    var fromLocalStorage = $228f9a1798c51d97$var$get(id);
    $228f9a1798c51d97$var$$$delete(id);
    return fromLocalStorage;
}
var $228f9a1798c51d97$export$398994a7cd250b7e = {
    contents: false
};
function $228f9a1798c51d97$export$aded8d3ce7fe43e1(bool) {
    $228f9a1798c51d97$export$398994a7cd250b7e.contents = bool;
}
function $228f9a1798c51d97$export$51e57029e6716073(param) {
    return $228f9a1798c51d97$export$398994a7cd250b7e.contents;
}
function $228f9a1798c51d97$export$c4ffdfe23dd48040(id) {
    var timeoutRef = $g85JO.useRef(undefined);
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var getInitialResult = function getInitialResult(localStorage) {
        return {
            position: $2whNH.getWithDefault($2whNH.map(id, function(param) {
                return $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, param);
            }), /* Zero */ 0),
            lock: undefined
        };
    };
    var getCurrentKey = function getCurrentKey(param) {
        return $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    };
    var key = $g85JO.useRef(getCurrentKey(undefined));
    $g85JO.useEffect(function() {
        return function(param) {
            $2whNH.forEach(timeoutRef.current, function(prim) {
                clearTimeout(prim);
            });
        };
    }, []);
    var match$1 = $g85JO.useState(function() {
        return getInitialResult(false);
    });
    var setResult = match$1[1];
    var setResult$1 = function setResult$1(fn) {
        $228f9a1798c51d97$export$398994a7cd250b7e.contents = true;
        $iv6Yc._1(setResult, fn);
        timeoutRef.current = $loT9g.some(setTimeout(function(param) {
            $228f9a1798c51d97$export$398994a7cd250b7e.contents = false;
        }, 100));
    };
    $25dxq.useBrowserNavigation(function(navigationType) {
        if (navigationType !== 1) return $2whNH.forEach(id, $228f9a1798c51d97$var$$$delete);
        var nextResult = getInitialResult(true);
        var match = nextResult.position;
        var nextResultValue = typeof match === "number" ? 0 : match._0;
        setResult$1(function(previousResult) {
            var match = previousResult.position;
            if (typeof match === "number" || match._0 < nextResultValue) return nextResult;
            else return previousResult;
        });
    }, []);
    $g85JO.useEffect(function() {
        setResult$1(function(param) {
            return getInitialResult(false);
        });
    }, [
        id
    ]);
    var update = function update(param) {
        if (id === undefined) return;
        var nextKey = getCurrentKey(undefined);
        if (key.current !== nextKey) {
            setResult$1(function(param) {
                return {
                    position: $228f9a1798c51d97$export$ff41c598de81c14a(namespace, false, id),
                    lock: $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents
                };
            });
            key.current = nextKey;
            return;
        }
    };
    $g85JO.useEffect(function() {
        $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.concat($kJhYp.getStatesByNamespace(namespace).localCallbacks, [
            update
        ]));
        return function(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.keep($kJhYp.getStatesByNamespace(namespace).localCallbacks, function(fn) {
                return fn !== update;
            }));
        };
    }, []);
    return match$1[0];
}
 /*  Not a pure module */ 
});
parcelRegister("25dxq", function(module, exports) {

$parcel$export(module.exports, "useBrowserNavigation", function () { return $18468cc594e5b21b$export$e8c1c060dda75c72; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2Mb3w = parcelRequire("2Mb3w");

var $052u6 = parcelRequire("052u6");
function $18468cc594e5b21b$var$useSafariHack(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : false;
    $052u6.LegacyNavigationTiming.useLegacyNavigationTiming(enabled, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
var $18468cc594e5b21b$export$e02aa0e39cbdc151 = {
    useSafariHack: $18468cc594e5b21b$var$useSafariHack
};
function $18468cc594e5b21b$export$e8c1c060dda75c72(callback, dependencies) {
    var isSafari = $2Mb3w.getBrowser(undefined) === /* Safari */ 1;
    $18468cc594e5b21b$var$useSafariHack(isSafari, callback, dependencies);
    $052u6.usePerformanceObserver1(!isSafari, true, /* Navigation */ 0, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
 /* PerformanceObserver-Showside Not a pure module */ 
});
parcelRegister("052u6", function(module, exports) {

$parcel$export(module.exports, "LegacyNavigationTiming", function () { return $00f26519795813cb$export$127e32ccb8a6e066; });
$parcel$export(module.exports, "usePerformanceObserver1", function () { return $00f26519795813cb$export$d2dfc13adeb0ed2d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
function $00f26519795813cb$export$48c17662a6902497(param) {
    return $2whNH.isSome(window.PerformanceObserver);
}
function $00f26519795813cb$export$e815e306a6ff66ed(entryType) {
    return "navigation";
}
function $00f26519795813cb$export$2fe53163c7bc4eaf(ext_type) {
    if (ext_type === "back_forward") return /* BackForward */ 1;
    else if (ext_type === "navigate") return /* Navigate */ 0;
    else return /* Reload */ 2;
}
function $00f26519795813cb$export$8ceb1d4b31259502(ext_entry) {
    return {
        _type: $00f26519795813cb$export$2fe53163c7bc4eaf(ext_entry.type)
    };
}
function $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, callback, dependencies) {
    var supported = $2whNH.isSome(window.PerformanceObserver);
    $g85JO.useEffect(function() {
        if (!(enabled && supported)) return;
        var observer = new PerformanceObserver(function(entries) {
            $iv6Yc._1(callback, $i7mYY.map(entries.getEntries(), $00f26519795813cb$export$8ceb1d4b31259502));
        });
        try {
            observer.observe(options);
            var observer$1 = observer;
            return function(param) {
                $2whNH.forEach(observer$1, function(obs) {
                    obs.disconnect();
                });
            };
        } catch (e) {
            return;
        }
    }, dependencies);
}
function $00f26519795813cb$var$useLegacyNavigationTiming(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var callback$1 = function callback$1(e) {
        $2whNH.forEach($2whNH.map($i7mYY.get(window.performance.getEntriesByType("navigation"), 0), function(entry) {
            return {
                _type: $2whNH.getWithDefault(e.persisted, false) ? /* BackForward */ 1 : ({
                    _type: $00f26519795813cb$export$2fe53163c7bc4eaf(entry.type)
                })._type
            };
        }), callback);
    };
    $g85JO.useEffect(function() {
        if (enabled) {
            window.addEventListener("pageshow", callback$1);
            return function(param) {
                window.removeEventListener("pageshow", callback$1);
            };
        }
    }, dependencies);
}
var $00f26519795813cb$export$127e32ccb8a6e066 = {
    useLegacyNavigationTiming: $00f26519795813cb$var$useLegacyNavigationTiming
};
function $00f26519795813cb$export$d2dfc13adeb0ed2d(enabledOpt, bufferedOpt, entryType, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var buffered = bufferedOpt !== undefined ? bufferedOpt : false;
    var options_type = "navigation";
    var options = {
        entryTypes: undefined,
        type: options_type,
        buffered: buffered
    };
    $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, function(entries) {
        $2whNH.forEach($i7mYY.get(entries, 0), callback);
    }, dependencies);
}
 /* react Not a pure module */ 
});



})();
//# sourceMappingURL=PDPApp.bs.6a030985.js.map
